var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomMessage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 52,
  viewBox: "0 0 53 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.4152 51.6971C40.6357 51.6971 52.1638 40.1691 52.1638 25.9486C52.1638 11.7281 40.6357 0.200073 26.4152 0.200073C12.1947 0.200073 0.666687 11.7281 0.666687 25.9486C0.666687 40.1691 12.1947 51.6971 26.4152 51.6971Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.8864 17.7138L26.793 25.8655C26.5703 25.9983 26.2843 26.0097 26.0465 25.8709L11.9441 17.7156V34.4118C11.9441 35.4082 12.7568 36.2203 13.7531 36.2203H39.0773C40.0736 36.2203 40.8864 35.4082 40.8864 34.4118V17.7138ZM13.7531 15.6769H39.0773C39.6101 15.6769 40.0917 15.9099 40.4228 16.2789L26.4167 24.3812L12.4076 16.28C12.7387 15.9104 13.2203 15.6769 13.7531 15.6769Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/customMessage.eccd79c5c3c643a326f10c383c87cdb7.svg";